import { MapPin } from 'lucide-react';

import Map from '@/app/location/Map';

import { Card, CardContent } from '@/components/ui/card';

const MeetingLocation = ({ booking }) => {
  return (
    <div>
      {/* Location  (From Offering Location)*/}
      {!booking.offeringIsMeetingSpot && (
        <Card>
          <CardContent className="p-4 space-y-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <MapPin className="h-5 w-5" />
                <h3 className="font-semibold">{booking.locationName}</h3>
              </div>
            </div>
            {booking.location && (
              <div className="aspect-video rounded-lg overflow-hidden">
                <Map location={booking.location} />
              </div>
            )}
          </CardContent>
        </Card>
      )}

      {/* Location  (From Offering Meeting Point)*/}
      {booking.offeringIsMeetingSpot && (
        <Card>
          <CardContent className="p-4 space-y-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <MapPin className="h-5 w-5" />
                <h3 className="font-semibold">
                  {booking.offeringMeetingLocationName || 'Meeting Point'}
                </h3>
              </div>
            </div>
            <div className="aspect-video rounded-lg overflow-hidden mb-4">
              <Map
                location={{
                  lat: booking.offeringMeetingLat,
                  lng: booking.offeringMeetingLng
                }}
              />
            </div>
            <span className="text-sm text-muted-foreground block">
              {booking.offeringMeetingLocationDetails}
            </span>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default MeetingLocation;
